import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import TongueCheck from "./tongue/check";
import TongueScan from "./tongue/scan";
import TongueList from "./tongue/list";
import TongueDetail from "./tongue/detail";

const router = createBrowserRouter([
    {
        path: "/scan",
        element: <TongueScan />,
    },
    {
        path: "/list",
        element: <TongueList />,
    },
    {
        path: "/detail",
        element: <TongueDetail />,
    },
    {
        path: "/check",
        element: <TongueCheck />,
    },
    {
        path: "*",
        element: <TongueScan />,
    },
]);

function App() {
    return <RouterProvider router={router} />;
}

export default App;
